import { render, staticRenderFns } from "./request-type-card.vue?vue&type=template&id=0e0a430f&scoped=true&"
import script from "./request-type-card.vue?vue&type=script&lang=js&"
export * from "./request-type-card.vue?vue&type=script&lang=js&"
import style0 from "./request-type-card.vue?vue&type=style&index=0&id=0e0a430f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a430f",
  null
  
)

export default component.exports